/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import Grid from "@mui/material/Grid";
import OGBox from "assets/theme/components/OGBox";
import DashboardNavbar from "assets/theme/components/OGNavbars/DashboardNavbar";
import DashboardLayout from "layout/containers/DashboardLayout";
import OGFooter from "assets/theme/components/OGFooter";
import AboutUs from "layout/routes/about/components";

function About() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <OGBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={12} lg={12}>
            <AboutUs key="aboutUs"> </AboutUs>
          </Grid>
        </Grid>
      </OGBox>
      <OGFooter />
    </DashboardLayout>
  );
}

export default About;
